import './ExtraVideoItem.scss'
import {useContext} from "react";
import AppContext from "../AppContext";
import {useTranslation} from "react-i18next";
export default function ExtraVideoItem({ id, video, recommended, currentVideo, setCurrentVideo }) {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    let className = ['extra_video-item']

    const openVideo = () => {
        setCurrentVideo(video)
    }

    if(video.watched)
        className.push('watched')

    if(recommended)
        className.push('current')


    return <div id={id} className={className.join(' ')} onClick={openVideo}>
        <img src={video.image} alt="" />
        <div className="extra_video-item-info">
            {!video.watched && <div className="extra_video-item-new">{t('extraVideos.newVideo')}</div>}
            <h3 className="title">
                <span dangerouslySetInnerHTML={{__html: video.name }} />
            </h3>
        </div>
    </div>
}